import { ApplicationTypeConstants } from './../../../services/warmup/warmup.service';
import { WarmUpService } from 'app/services/warmup/warmup.service';
import { Observable } from 'rxjs/Observable';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { Component, OnInit, Input } from '@angular/core';

import { PersonHeaderService } from 'app/person/header/person-header.service';
import { ClientHeaderService } from 'app/clients/client/header/client-header.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

@Component({
  selector: 'monitoring-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})


/**
 * Component to display the monitoring history for the entity.
 */
export class HistoryComponent implements OnInit {
  @Input() entityIdDetails: EntityIdDetails;
  systemInfo: any;
  monitoringHistory = {};
  matchResolutions: ApplicationValue[];
  falseMatchReasons: ApplicationValue[];
  sanctionMatchResolutions: ApplicationValue[];
  modelEntityMap = {
    Sanction: 'sanctionEntity',
    Pep: 'pepEntity',
    Badpress: 'badPressEntity'
  };

  monitoringMatchTypes = [];
  fieldMap = {
    Sanction: {
      firstName: 'First Name',
      middleName: 'Middle Name',
      lastName: 'Last Name',
      globalName: 'Global Name',
      listName: 'List Name',
      birthDate: 'Date of Birth',
      birthCountry: 'Country of Birth',
      nationality: 'Nationality',
      comments: 'Additional comments'
    },
    Badpress: {
      name: 'Name',
      address: 'Address',
      countryCodes: 'Country Code',
      countries: 'Countries',
      status: 'Status',
      recordType: 'Record Type',
      sourceID: 'Source',
      valid_until: 'Valid upto',
      incorporation_date: 'Incorporation Date',
      jurisdiction_description: 'Jurisdiction : Jurisdiction Description',
      dorm_date: 'Dorm Date',
      struck_off_date: 'Struck Off Date'
    },
    Pep: {
      firstName: 'First Name',
      lastName: 'Last Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      description: 'Description',
      country: 'Country',
      designation: 'Designation',
      globalName: 'Global Name',
    }
  };

  sourceFieldMap = {
    Sanction: {
      firstName: 'firstNames',
      lastName: 'lastNames',
      nationality: 'nationalityName',
      globalName: 'wholeName',
      birthDate: 'birthdayPrint'
    },
    Badpress: {
    },
    Pep: {
      firstName: 'firstNames',
      lastName: 'lastNames',
      nationality: 'nationalityName',
      globalName: 'wholeName',
      birthDate: 'birthdayPrint'
    }
  };

  cols = [
    { field: 'date', header: 'Resolution Date' },
    { field: 'type', header: 'Type' },
    { field: 'source', header: 'Source' },
    { field: 'matchResolution', header: 'Match Resolution' },
    { field: 'falseMatchReason', header: 'False match reason' }
  ];

  constructor(
    private entityMonitoringService: EntityMonitoringService,
    private personHeaderService: PersonHeaderService,
    private clientHeaderService: ClientHeaderService,
    private warmUpService: WarmUpService
  ) { }

  ngOnInit() {
    this.getBadpressHistory();
    this.getPepHistory();
    this.getSanctionHistory();
    this.getSystemInfo();
    const setMatchResolutions = (values) => { this.matchResolutions = values; };
    const setFalseMatchReasons = (values) => { this.falseMatchReasons = values; };
    const setSanctionMatchResolutions = (values) => { this.sanctionMatchResolutions = values; };
    this.warmUpService.getApplicationValueList(ApplicationTypeConstants.SANCTION_MATCH_RESOLUTION, setSanctionMatchResolutions);
    this.warmUpService.getApplicationValueList(ApplicationTypeConstants.PANAMA_PAPERS_MATCH_RESOLUTION, setMatchResolutions);
    this.warmUpService.getApplicationValueList(ApplicationTypeConstants.FALSE_MATCH_REASONS, setFalseMatchReasons);
  }

  getBadpressHistory() {
    this.entityMonitoringService.getBadPressHistory(this.entityIdDetails.entityId).subscribe(
      response => {
        this.monitoringHistory['Badpress'] = this.updateFieldValue(response.suggestionList, 'Badpress');
        if (response.suggestionList.length) {
          this.monitoringMatchTypes.push('Badpress');
        }


      });
  }

  getSanctionHistory() {
    this.entityMonitoringService.getSanctionHistory(this.entityIdDetails.entityId).subscribe(
      response => {
        this.monitoringHistory['Sanction'] = this.updateFieldValue(response.suggestionList, 'Sanction');
        if (response.suggestionList.length) {
          this.monitoringMatchTypes.push('Sanction');
          this.fieldMap.Sanction.birthDate =
            this.entityIdDetails.isPerson && 'Date of Birth' || 'Incorporation date';
          this.fieldMap.Sanction.birthCountry =
            this.entityIdDetails.isPerson && 'Country of Birth' || 'Country of incorporation';
        }
      });
  }

  getPepHistory() {
    if (this.entityIdDetails.entityType === EntityType.PERSON) {
      this.entityMonitoringService.getPepHistory(this.entityIdDetails.entityId).subscribe(
        response => {
          this.monitoringHistory['Pep'] = this.updateFieldValue(response.suggestionList, 'Pep');
          if (response.suggestionList.length) {
            this.monitoringMatchTypes.push('Pep');
          }
        });
    }
  }

  updateFieldValue(jsonObject, type) {
    for (let obj of jsonObject) {
      obj.type = type;
      if(type!='Badpress'){
        obj.matchResolution = this.getApplicationNameFromId(obj.matchResolution, this.sanctionMatchResolutions);
      }else{
        obj.matchResolution = this.getApplicationNameFromId(obj.matchResolution, this.matchResolutions);
      }
      obj.source =
        obj[this.modelEntityMap[type]].hasOwnProperty('source') && obj[this.modelEntityMap[type]]['source'] || 'N/A';
      obj.falseMatchReason = obj.falseMatchReason === null && 'N/A'
      || this.getApplicationNameFromId(obj.falseMatchReason, this.falseMatchReasons);
      if (type === 'Badpress') {
        const jsonData = JSON.parse(obj.badPressEntity.jsonData);
        obj.sourceID = jsonData.sourceID;
        obj.valid_until = jsonData.valid_until;
        obj.incorporation_date = jsonData.incorporation_date;
        obj.jurisdiction_description = jsonData.jurisdiction_description;
        obj.dorm_date = jsonData.dorm_date;
        obj.struck_off_date = jsonData.struck_off_date;
      }
    }
    return jsonObject;
  }

  getKeys(type: string) {
    return Object.keys(this.fieldMap[type]);
  }

  getSystemInfo() {
    if (this.entityIdDetails.isPerson) {
      this.personHeaderService.getPerson(this.entityIdDetails.personId)
        .subscribe(response => {
          response.arrResult.birthdayPrint = this.entityMonitoringService.getDateForPrint(response.arrResult.birthday);
          this.systemInfo = response.arrResult;
        });
    } else {
      this.clientHeaderService.getOrganisationDetails(this.entityIdDetails.orgId)
        .subscribe(response => {
          if (response.organisationVO.incorporatedDate) {
            response.organisationVO.incorporateDate =
            this.entityMonitoringService.getDateForPrint(response.organisationVO.incorporatedDate);
          }
          this.systemInfo = response.organisationVO;
        });
    }
  }

  getSystemValue(key) {
    return this.systemInfo.hasOwnProperty(key) && this.systemInfo[key] || '';
  }

  getApplicationNameFromId(id, typeList) {
    if (typeList) {
      const match = typeList.find(type  => type.id === id);
      if (match) {
        return match.name;
      }
    }
    return 'N/A';
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/history/history.component.ts